import { useTranslation } from "react-i18next";
import styles from "./StepHeader.module.scss";

interface StepHeaderProps {
	title: string;
	onBack?: () => void;
}

export const StepHeader = ({ title, onBack }: StepHeaderProps) => {
	const { t } = useTranslation();
	return (
		<div className={styles.header}>
			{onBack && (
				<button type="button" className={styles.backButton} onClick={onBack} aria-label={t("auth.web.goBack")}>
					<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
						<path
							d="M14 5L8 11L14 17"
							stroke="var(--app-primary-text)"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
			)}
			<h1 className={styles.title}>{title}</h1>
		</div>
	);
};
